import React from 'react'
import Select from './Select'
import Input from './Input'
import Range from './Range'
import Checkbox from './Checkbox'

export default function InputGroup({
	modes,
	mode,
	setMode,
	color,
	setColor,
	amount,
	setAmount,
	corrected,
	setCorrected,
}) {
	return (
		<div className="p-4 space-y-6 max-w-lg">
			<div className="flex space-x-4 items-start">
				<label className="space-y-1">
					<p className="text-black text-sm select-none">Blend Mode</p>
					<Select options={modes} setMode={setMode} mode={mode} />
				</label>
				<label className="space-y-1 flex-grow">
					<p className="text-black text-sm select-none">Base Color</p>
                    <Input color={color} setColor={setColor} />
				</label>
			</div>
			<div className="flex sm:flex-row flex-col sm:space-x-8 items-start">
				<label className="space-y-1 flex space-x-3 items-center py-1">
					<p className="text-black text-sm select-none">Quantity</p>
					<Range amount={amount} setAmount={setAmount} />
				</label>
				<label className="space-y-1 flex space-x-2 items-center py-1">
					<p className="text-black text-sm whitespace-no-wrap select-none">Smooth Lightness</p>
					<Checkbox corrected={corrected} setCorrected={setCorrected} />
				</label>
			</div>
		</div>
	)
}
